import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("studio_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve image URLs: backend-served files are relative (/api/files/...)
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

// Convert a Tally form URL (/r/ID) into an embeddable URL (/embed/ID).
export const toTallyEmbed = (url) => {
  if (!url) return null;
  const m = url.match(/tally\.so\/(?:r|embed)\/([\w-]+)/);
  if (!m) return url;
  return `https://tally.so/embed/${m[1]}?transparentBackground=1&hideTitle=1&dynamicHeight=1`;
};
// Extract a YouTube video ID from watch / youtu.be / embed / shorts URLs.
export const youtubeId = (url) => {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : null;
};

// Build a YouTube thumbnail URL for a given video URL.
export const youtubeThumb = (url, quality = "maxresdefault") => {
  const id = youtubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/${quality}.jpg` : null;
};

// Resolve the poster to show for a project: uploaded thumbnail always wins,
// otherwise fall back to the YouTube thumbnail when the video URL is a YouTube link.
export const projectPoster = (project) => {
  if (project?.thumbnail) return { src: resolveImg(project.thumbnail), fromYouTube: false };
  const yt = youtubeThumb(project?.video_url);
  if (yt) return { src: yt, fromYouTube: true };
  return { src: "", fromYouTube: false };
};

export const toEmbedUrl = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0&modestbranding=1`;
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`;
  return null; // treat as direct video file
};
